var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_267_908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7595 23.4863C40.9282 20.1712 36.0718 20.1712 35.2405 23.4863C35.1164 23.9844 34.873 24.4471 34.5301 24.8366C34.1871 25.226 33.7544 25.5314 33.267 25.7277C32.7796 25.924 32.2514 26.0058 31.7254 25.9664C31.1994 25.927 30.6903 25.7674 30.2397 25.5008C27.2384 23.7243 23.8039 27.0606 25.6327 29.9761C26.814 31.8589 25.7662 34.3155 23.5611 34.8361C20.1463 35.6415 20.1463 40.3612 23.5611 41.1644C24.074 41.2852 24.5504 41.5218 24.9513 41.8552C25.3523 42.1886 25.6665 42.6093 25.8684 43.083C26.0703 43.5566 26.1542 44.07 26.1133 44.5811C26.0723 45.0922 25.9077 45.5868 25.6327 46.0244C23.8039 48.9399 27.2384 52.2762 30.2397 50.4997C30.6902 50.2326 31.1993 50.0727 31.7255 50.0329C32.2517 49.9931 32.7801 50.0746 33.2677 50.2708C33.7554 50.4669 34.1884 50.7721 34.5316 51.1616C34.8748 51.5511 35.1184 52.0138 35.2427 52.5121C36.0718 55.8293 40.9304 55.8293 41.7573 52.5121C41.882 52.0141 42.1259 51.5517 42.4691 51.1625C42.8124 50.7733 43.2454 50.4682 43.7329 50.2721C44.2203 50.076 44.7486 49.9945 45.2746 50.034C45.8006 50.0735 46.3096 50.2331 46.7603 50.4997C49.7616 52.2762 53.1961 48.9399 51.3673 46.0244C51.0928 45.5867 50.9286 45.0922 50.8879 44.5812C50.8472 44.0702 50.9311 43.5571 51.133 43.0835C51.3348 42.61 51.6489 42.1894 52.0495 41.8559C52.4502 41.5225 52.9262 41.2856 53.4389 41.1644C56.8537 40.3591 56.8537 35.6394 53.4389 34.8361C52.926 34.7154 52.4496 34.4787 52.0487 34.1453C51.6477 33.8119 51.3335 33.3913 51.1316 32.9176C50.9297 32.4439 50.8458 31.9306 50.8867 31.4194C50.9277 30.9083 51.0923 30.4138 51.3673 29.9761C53.1961 27.0606 49.7616 23.7243 46.7603 25.5008C46.3098 25.7679 45.8007 25.9278 45.2745 25.9676C44.7483 26.0074 44.2199 25.9259 43.7323 25.7298C43.2446 25.5336 42.8116 25.2284 42.4684 24.8389C42.1252 24.4494 41.8816 23.9867 41.7573 23.4884L41.7595 23.4863Z",
    stroke: "#EE8142",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3889 38C42.3889 40.0864 40.6478 41.7778 38.5 41.7778C36.3522 41.7778 34.6111 40.0864 34.6111 38C34.6111 35.9136 36.3522 34.2222 38.5 34.2222C40.6478 34.2222 42.3889 35.9136 42.3889 38Z",
    stroke: "#EE8142",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_267_908",
    x: -11.5,
    y: -12,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.0745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_267_908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_267_908",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.5f5f5d1b8d52068a762d59e68090a5c6.svg";
export { ForwardRef as ReactComponent };